import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LangugageDetector from "i18next-browser-languagedetector";
export const languages = {
  en: { name: "English", dir: "ltr", fontClass:"font-en"},
  fa: { name: "قارسی", dir:"rtl", fontClass:"font-fa"}
}

export const getSavedLanguage = (): string| null => {
  const saved = localStorage.getItem("preferred-language")
  if( saved && ( saved === "en" || saved ==="fa")){
    return saved
  }
  return null
}

i18n.use(Backend).use(LangugageDetector).use(initReactI18next).init({
  fallbackLng: "fa",
  whitelist: ["en", "fa"],
  debug: false,
  lng: getSavedLanguage() || undefined,
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: false
  }
});
export default i18n